<template>
  <div class="contents">
    <div class="wrap">
      <!-- 검색 영역 -->
      <section>
        <h2 class="page_title --view">결제정산현황</h2>
        <article>
          <ul class="search_filter">
            <li>
              <p>조회기간</p>
              <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYYMMDD'" />
              <span>~</span>
              <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYYMMDD'" />
            </li>
            <li>
              <p>처방의명</p>
              <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.doctorNm" @keyup.enter="fn_search">
            </li>
            <li>
              <p>환자명</p>
              <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.patientNm" @keyup.enter="fn_search">
            </li>
            <li>
              <p>주문코드</p>
              <input type="text" placeholder="입력하세요" class="form_control" v-model="searchInfo.orderCode" @keyup.enter="fn_search">
            </li>
            <li>
              <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
            </li>
          </ul>
        </article>
      </section>

      <!-- 요약 카드 영역 -->
      <section class="view">
        <div class="summary_area">
          <div class="summary_card" v-for="card in summaryCards" :key="card.key">
            <p class="card_label">{{ card.label }}</p>
            <strong class="card_value" :class="card.colorClass">{{ fn_comma_won(summaryInfo[card.key]) }}원</strong>
          </div>
        </div>
      </section>

      <!-- 목록 테이블 -->
      <section class="view">
        <div class="table_list">
          <table class="list">
            <thead>
              <tr>
                <th>결제일시</th>
                <th>주문코드</th>
                <th>처방의</th>
                <th>환자명</th>
                <th>주문금액</th>
                <th>카드결제</th>
                <th>무통장입금</th>
                <th>예치금사용</th>
                <th>포인트사용</th>
                <th>실결제금액</th>
                <th>결제상태</th>
                <th>상세</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="settlementList.length === 0">
                <td colspan="11" class="ac"><span>조회된 데이터가 없습니다.</span></td>
              </tr>
              <tr v-for="(item, index) in settlementList" :key="index">
                <td><span>{{ item.payment_complete_dt }}</span></td>
                <td><span>{{ item.order_code }}</span></td>
                <td><span>{{ item.doctor_nm }}</span></td>
                <td><span>{{ item.patient_nm }}</span></td>
                <td><span>{{ fn_comma_won(item.total_price) }}</span></td>
                <td><span>{{ fn_comma_won(item.card_price) }}</span></td>
                <td><span>{{ fn_comma_won(item.bank_price) }}</span></td>
                <td><span>{{ fn_comma_won(item.deposit_used_price) }}</span></td>
                <td><span>{{ fn_comma_won(item.point_used_price) }}</span></td>
                <td><span>{{ fn_comma_won(item.pay_price+item.deposit_used_price) }}</span></td>
                <td>
                  <span class="status_badge" :class="getPaymentBadgeClass(item.payment_status)">
                    {{ item.payment_status_nm }}
                  </span>
                </td>
                <!--
                <td>
                  <span class="status_badge" :class="getSettleBadgeClass(item.settle_status)">
                    {{ item.settle_status_nm }}
                  </span>
                </td>
                -->
                <td>
                  <button class="btn btn_sm btn_outline" @click="fn_open_detail(item)">상세</button>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow" />
        </div>
      </section>
    </div>

    <!-- 상세 팝업 모달 -->
    <SettlementDetailModal :selectedItem="selectedItem" />
  </div>
</template>

<script>
  import axios from 'axios'
  import commonUtil from '@/mixin/commonUtil'
  import Pagination from '@/components/AdminPagination.vue'
  import Datepicker from '@/components/Datepicker.vue'
  import SettlementDetailModal from '@/modal/admin/settlementDetailModal.vue'

  export default {
    name: 'SettlementList',
    components: {
      Pagination,
      Datepicker,
      SettlementDetailModal
    },
    mixins: [commonUtil],
    data() {
      return {
        searchInfo: {
          startDate: '',
          endDate: '',
          doctorNm: '',
          patientNm: '',
          orderCode: '',
          paymentStatus: '',
          // settleStatus: '',  // 정산상태 - 추후 사용
          pageInfo: {
            page: 1,
            pageSize: 10,
            totPage: 0
          }
        },
        pagingShow: false,
        settlementList: [],
        summaryInfo: {
          total_amt: 0,
          card_amt: 0,
          deposit_amt: 0,
          point_amt: 0,
          real_settle_amt: 0
        },
        summaryCards: [
          { key: 'total_amt',      label: '총 결제금액',    colorClass: '' },
          { key: 'card_amt',       label: '카드 결제금액',  colorClass: '' },
          { key: 'bank_amt',    label: '무통장 입금액', colorClass: '' },
          { key: 'deposit_amt',    label: '예치금 사용금액', colorClass: '' },
          { key: 'point_amt',      label: '포인트 사용금액', colorClass: 'text_green' },
          { key: 'real_settle_amt', label: '실 정산금액',   colorClass: 'text_blue' }
        ],
        selectedItem: null,
        paymentStatusList: []
      }
    },
    async created() {
      const searchInfoStore = this.$store.getters['commonStore/getSearchInfo']
      if (searchInfoStore != null && Object.keys(searchInfoStore).length > 0) {
        this.searchInfo = searchInfoStore
      }

      const statusList = await this.getCode('GC00000013')
      this.paymentStatusList = statusList.filter(item => ['COMP', 'CANC'].includes(item.dtl_code))
    },
    mounted() {
      const today = new Date()
      const year = today.getFullYear()
      const month = (today.getMonth() + 1).toString().padStart(2, '0')
      const day = today.getDate().toString().padStart(2, '0')
      this.searchInfo.startDate = `${year}-${month}-01`
      this.searchInfo.endDate = `${year}-${month}-${day}`

      this.fn_search()
    },
    methods: {
      fn_search() {
        this.searchInfo.pageInfo.page = 1
        this.fn_fetch()
      },
      fn_fetch() {
        this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo)

        axios.post('/api/admin/settlement/getSettlementList', this.searchInfo)
          .then((res) => {
            this.settlementList = res.data.settlementList
            this.summaryInfo    = res.data.summaryInfo
            this.searchInfo.pageInfo.totPage = res.data.totCnt
            this.pagingShow = this.searchInfo.pageInfo.totPage > 0
          })
          .catch((err) => console.log(err))
      },
      fn_movePage(page) {
        this.searchInfo.pageInfo.page = page
        this.fn_fetch()
      },
      fn_open_detail(item) {
        this.selectedItem = { ...item }
        this.$bvModal.show('settlementDetailModal')
      },
      getPaymentBadgeClass(status) {
        if (status === 'COMP') return 'badge_blue'
        if (status === 'CANC') return 'badge_red'
        return ''
      }
    }
  }
</script>

<style scoped>
  .summary_area {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  .summary_card {
    flex: 1;
    min-width: 140px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 18px 20px;
    box-shadow: 0 1px 4px rgba(0,0,0,0.05);
  }
  .card_label {
    font-size: 1.3rem;
    color: #888;
    margin-bottom: 8px;
  }
  .card_value {
    font-size: 1.8rem;
    font-weight: 700;
    color: #262939;
  }
  .text_blue { color: #2b6cb0; }
  .text_green { color: #28a745; }

  .status_badge {
    display: inline-block;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 1.2rem;
    font-weight: 600;
    white-space: nowrap;
  }
  .badge_blue   { background: #ebf4ff; color: #2b6cb0; }
  .badge_red    { background: #fff5f5; color: #c53030; }
  /* .badge_green  { background: #f0fff4; color: #276749; } */
  /* .badge_gray   { background: #f7fafc; color: #718096; } */

  .ar { text-align: right; }
  .ac { text-align: center; }
</style>